// import React, { useState } from 'react';`n// import {
//   Box,
//   Typography,
//   Button,
//   Paper,
//   TextField,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableFooter,
//   TablePagination,
//   IconButton,
//   InputAdornment,
// } from '@mui/material';
// import { styled, useTheme } from '@mui/material/styles';
// import AppLayout from '../components/AppLayout';

// import {
//   FirstPage as FirstPageIcon,
//   KeyboardArrowLeft,
//   KeyboardArrowRight,
//   LastPage as LastPageIcon,
//   Download as DownloadIcon,
//   Visibility as VisibilityIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   Search as SearchIcon,
// } from '@mui/icons-material';

// // =================== STYLED COMPONENTS ===================
// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${theme.palette.mode === 'light' ? 'MuiTableCell-head' : ''}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//     fontWeight: 'bold',
//   },
//   fontSize: 14,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: theme.palette.action.hover,
//   },
// }));

// // =================== PAGINATION CONTROLS ===================
// function TablePaginationActions(props) {
//   const theme = useTheme();
//   const { count, page, rowsPerPage, onPageChange } = props;

//   const handleFirstPageButtonClick = (event) => onPageChange(event, 0);
//   const handleBackButtonClick = (event) => onPageChange(event, page - 1);
//   const handleNextButtonClick = (event) => onPageChange(event, page + 1);
//   const handleLastPageButtonClick = (event) =>
//     onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));

//   return (
//     <Box sx={{ flexShrink: 0, ml: 2.5 }}>
//       <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0}>
//         {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
//       </IconButton>
//       <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
//         {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
//       </IconButton>
//       <IconButton
//         onClick={handleNextButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//       >
//         {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
//       </IconButton>
//       <IconButton
//         onClick={handleLastPageButtonClick}
//         disabled={page >= Math.ceil(count / rowsPerPage) - 1}
//       >
//         {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
//       </IconButton>
//     </Box>
//   );
// }

// // =================== SAMPLE DATA ===================
// const rows = [
//   {
//     id: 'GFS-0039',
//     name: 'John Doe',
//     photo: 'https://via.placeholder.com/40',
//     timestamp: '2025-11-11 14:30:00',
//   },
//   {
//     id: 'GFS-0040',
//     name: 'Jane Smith',
//     photo: 'https://via.placeholder.com/40',
//     timestamp: '2025-11-10 10:15:00',
//   },
//   {
//     id: 'GFS-0041',
//     name: 'Mark Lee',
//     photo: 'https://via.placeholder.com/40',
//     timestamp: '2025-11-09 16:00:00',
//   },
//   {
//     id: 'GFS-0042',
//     name: 'Sara Khan',
//     photo: 'https://via.placeholder.com/40',
//     timestamp: '2025-11-08 09:45:00',
//   },
//   {
//     id: 'GFS-0043',
//     name: 'Amit Patel',
//     photo: 'https://via.placeholder.com/40',
//     timestamp: '2025-11-07 18:25:00',
//   },
// ];

// // =================== MAIN COMPONENT ===================
// export default function BillCreation() {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage] = useState(3);
//   const [search, setSearch] = useState('');
//   const [ setSearchClicked] = useState(false);

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredRows = rows.filter(
//     (row) =>
//       row.id.toLowerCase().includes(search.toLowerCase()) ||
//       row.name.toLowerCase().includes(search.toLowerCase())
//   );

//   const handleSearch = () => {
//     setSearchClicked(true);
//     setPage(0);
//   };

//   const emptyRows =
//     page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredRows.length) : 0;

//   return (
//     <AppLayout>
//       <Box sx={{ maxWidth: '1200px', mx: 'auto' }}>
//         {/* Header Section */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 3,
//           }}
//         >
//           <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: 2 }}>
//             BILL CREATION
//           </Typography>

//           <Button
//             variant="contained"
//             sx={{
//               bgcolor: '#C59A58',
//               '&:hover': { bgcolor: '#b68649' },
//             }}
//           >
//             SORT BY DATE ▾
//           </Button>
//         </Box>

//         {/* Search Bar */}
//         <TextField
//           fullWidth
//           label="Search by ID or Name..."
//           variant="outlined"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//           sx={{ mb: 3 }}
//           InputProps={{
//             endAdornment: (
//               <InputAdornment position="end">
//                 <IconButton
//                   onClick={handleSearch}
//                   sx={{
//                     bgcolor: '#C59A58',
//                     color: 'white',
//                     '&:hover': { bgcolor: '#b68649' },
//                   }}
//                 >
//                   <SearchIcon />
//                 </IconButton>
//               </InputAdornment>
//             ),
//           }}
//         />

//         {/* Table */}
//         <TableContainer component={Paper} elevation={6} sx={{ borderRadius: 2 }}>
//           <Table sx={{ minWidth: 900 }} aria-label="customized table">
//             <TableHead>
//               <TableRow>
//                 <StyledTableCell>Photo</StyledTableCell>
//                 <StyledTableCell>ID</StyledTableCell>
//                 <StyledTableCell>Name</StyledTableCell>
//                 <StyledTableCell>Timestamp</StyledTableCell>
//                 <StyledTableCell align="center">Download</StyledTableCell>
//                 <StyledTableCell align="center">View</StyledTableCell>
//                 <StyledTableCell align="center">Edit</StyledTableCell>
//                 <StyledTableCell align="center">Delete</StyledTableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {(rowsPerPage > 0
//                 ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                 : filteredRows
//               ).map((row) => (
//                 <StyledTableRow key={row.id}>
//                   <StyledTableCell>
//                     <img
//                       src={row.photo}
//                       alt={row.name}
//                       style={{
//                         width: 40,
//                         height: 40,
//                         borderRadius: '50%',
//                         objectFit: 'cover',
//                       }}
//                     />
//                   </StyledTableCell>

//                   <StyledTableCell>{row.id}</StyledTableCell>
//                   <StyledTableCell>{row.name}</StyledTableCell>
//                   <StyledTableCell>{row.timestamp}</StyledTableCell>

//                   <StyledTableCell align="center">
//                     <IconButton color="primary" aria-label={`download-${row.id}`}>
//                       <DownloadIcon />
//                     </IconButton>
//                   </StyledTableCell>
//                   <StyledTableCell align="center">
//                     <IconButton color="success" aria-label={`view-${row.id}`}>
//                       <VisibilityIcon />
//                     </IconButton>
//                   </StyledTableCell>
//                   <StyledTableCell align="center">
//                     <IconButton color="warning" aria-label={`edit-${row.id}`}>
//                       <EditIcon />
//                     </IconButton>
//                   </StyledTableCell>
//                   <StyledTableCell align="center">
//                     <IconButton color="error" aria-label={`delete-${row.id}`}>
//                       <DeleteIcon />
//                     </IconButton>
//                   </StyledTableCell>
//                 </StyledTableRow>
//               ))}

//               {emptyRows > 0 && (
//                 <TableRow style={{ height: 53 * emptyRows }}>
//                   <TableCell colSpan={8} />
//                 </TableRow>
//               )}
//             </TableBody>

//             <TableFooter>
//               <TableRow>
//                 <TablePagination
//                   rowsPerPageOptions={[3]}
//                   colSpan={8}
//                   count={filteredRows.length}
//                   rowsPerPage={rowsPerPage}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   ActionsComponent={TablePaginationActions}
//                 />
//               </TableRow>
//             </TableFooter>
//           </Table>
//         </TableContainer>

//         {/* Create Bill Button */}
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{
//               bgcolor: '#C59A58',
//               '&:hover': { bgcolor: '#b68649' },
//               px: 3,
//             }}
//           >
//             Create Bill
//           </Button>
//         </Box>

//         {/* Decorative Bottom Fade */}
//         <Box
//           sx={{
//             mt: 4,
//             height: 40,
//             background: 'linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.3))',
//             borderRadius: 2,
//           }}
//         />
//       </Box>
//     </AppLayout>
//   );
// }

// import React, { useState } from "react";`n// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   IconButton,
//   TextField,
//   InputAdornment,
//   // Grid,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import AppLayout from "../../components/AppLayout";

// // Sample dummy data
// const billData = [
//   { id: 1, name: "John Doe", timeStamp: "2025-11-11 12:00 PM", item: "T-Shirt", quantity: 2, price: "₹500", status: "Paid" },
//   { id: 2, name: "Priya Mehta", timeStamp: "2025-11-11 02:15 PM", item: "Shoes", quantity: 1, price: "₹1200", status: "Pending" },
//   { id: 3, name: "Kabir Menon", timeStamp: "2025-11-10 04:30 PM", item: "Watch", quantity: 1, price: "₹2500", status: "Paid" },
//   { id: 4, name: "Diya Kothari", timeStamp: "2025-11-09 10:45 AM", item: "Bag", quantity: 1, price: "₹900", status: "Pending" },
//   { id: 5, name: "Ravi Patel", timeStamp: "2025-11-08 05:20 PM", item: "Hat", quantity: 3, price: "₹600", status: "Paid" },
// ];

// function BillCreation() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const rowsPerPage = 3;

//   const handleSearch = (e) => setSearchTerm(e.target.value);
//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredRows = billData.filter(
//     (row) =>
//       row.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       row.item.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <AppLayout>
//       <Box sx={{ maxWidth: "1200px", mx: "auto", mt: 2 }}>
//         {/* Header Section */}
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//           <Typography variant="h3" sx={{ fontWeight: 800, letterSpacing: 2 }}>
//             BILL CREATION
//           </Typography>
//           <TextField
//             placeholder="Search..."
//             variant="outlined"
//             size="small"
//             value={searchTerm}
//             onChange={handleSearch}
//             sx={{
//               // backgroundColor: "#fff",s
//               borderRadius: "50px",
//               width: 250,
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "50px",
//               },
//             }}
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={() => console.log("Searching:", searchTerm)}
//                     sx={{
//                       backgroundColor: "#C59A58",
//                       color: "white",
//                       "&:hover": { backgroundColor: "#b68649" },
//                     }}
//                   >
//                     <SearchIcon />
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {/* Table Section */}
//         <Paper
//           elevation={6}
//           sx={{
//             p: 3,
//             borderRadius: 3,
//             backgroundColor: "#F9F9F9",
//           }}
//         >
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow
//                   sx={{
//                     backgroundColor: "#C59A58",
//                     "& th": { color: "white", fontWeight: "bold", border: "none" },
//                   }}
//                 >
//                   <TableCell>ID</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Timestamp</TableCell>
//                   <TableCell>Item</TableCell>
//                   <TableCell>Quantity</TableCell>
//                   <TableCell>Price</TableCell>
//                   <TableCell>Status</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredRows
//                   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                   .map((row) => (
//                     <TableRow
//                       key={row.id}
//                       sx={{
//                         "&:hover": { backgroundColor: "#f5f5f5" },
//                         "& td": { border: "none" }, // remove inner borders
//                       }}
//                     >
//                       <TableCell>{row.id}</TableCell>
//                       <TableCell>{row.name}</TableCell>
//                       <TableCell>{row.timeStamp}</TableCell>
//                       <TableCell>{row.item}</TableCell>
//                       <TableCell>{row.quantity}</TableCell>
//                       <TableCell>{row.price}</TableCell>
//                       <TableCell>
//                         <Typography
//                           sx={{
//                             backgroundColor: row.status === "Paid" ? "#4CAF50" : "#E57373",
//                             color: "white",
//                             px: 1.5,
//                             py: 0.5,
//                             borderRadius: 2,
//                             textAlign: "center",
//                             display: "inline-block",
//                             fontSize: "0.85rem",
//                           }}
//                         >
//                           {row.status}
//                         </Typography>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//               </TableBody>

//               {/* Pagination Footer */}
//               <tfoot>
//                 <TableRow
//                   sx={{
//                     backgroundColor: "#C59A58",
//                     "& .MuiTablePagination-root": { color: "white" },
//                     "& .MuiTablePagination-selectIcon": { color: "white" },
//                   }}
//                 >
//                   <TablePagination
//                     rowsPerPageOptions={[3]}
//                     count={filteredRows.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     colSpan={7}
//                     sx={{
//                       color: "white",
//                       ".MuiTablePagination-toolbar": {
//                         color: "white",
//                       },
//                       ".MuiTablePagination-actions button": {
//                         color: "white",
//                       },
//                     }}
//                   />
//                 </TableRow>
//               </tfoot>
//             </Table>
//           </TableContainer>
//         </Paper>

//         {/* Gradient Footer */}
//         <Box
//           sx={{
//             mt: 4,
//             height: 40,
//             background: "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.3))",
//             borderRadius: 2,
//           }}
//         />
//       </Box>
//     </AppLayout>
//   );
// }

// export default BillCreation;

import React, { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  IconButton,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
  Alert,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  Search as SearchIcon,
  Download as DownloadIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Sms as SmsIcon,
} from "@mui/icons-material";
import AppLayout from "../../components/AppLayout";
import { getInitials, getAvatarColor } from "../../utils/avatarUtils";
import { generateBillPDF } from "../../utils/pdfGenerator";
import API_BASE_URL from "../../config/api";

export default function BillCreation() {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(() => {
    // Restore page from sessionStorage on component mount
    const savedPage = sessionStorage.getItem('billsListPage');
    return savedPage ? parseInt(savedPage, 10) : 0;
  });
  const [billData, setBillData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [billToDelete, setBillToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [sendingSMS, setSendingSMS] = useState({});
  const [smsDialogOpen, setSmsDialogOpen] = useState(false);
  const [selectedBillForSMS, setSelectedBillForSMS] = useState(null);
  const rowsPerPage = 5;
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role");

  useEffect(() => {
    fetchBills();
    
    // Cleanup function to clear page when component unmounts due to navigation away
    return () => {
      // Only clear if we're navigating to a non-bill route
      const currentPath = window.location.pathname;
      if (!currentPath.includes('bill')) {
        sessionStorage.removeItem('billsListPage');
      }
    };
  }, []);

  // Save page to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem('billsListPage', page.toString());
  }, [page]);

  const fetchBills = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/bills/all`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error("Failed to fetch bills");
      }

      const data = await response.json();
      setBillData(data.bills || []);
      setError(null);
    } catch (err) {
      console.error("Error fetching bills:", err);
      setError("Failed to load bills. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleSearchClick = () => {
    setPage(0);
    // console.log("Search clicked:", searchTerm);
  };
  const handleChangePage = (event, newPage) => setPage(newPage);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleDeleteClick = (bill) => {
    setBillToDelete(bill);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!billToDelete || isDeleting) return;

    setIsDeleting(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/bills/${billToDelete.BillId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        toast.success(data.message || "Bill deleted successfully!");
        
        // Dispatch event to refresh customer data (for coupon updates)
        // Trigger data refresh events
        setTimeout(() => {
          window.dispatchEvent(new Event('refreshCustomerData'));
          window.dispatchEvent(new Event('refreshDashboardData'));
        }, 500);
        
        fetchBills(); // Refresh the list
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete bill");
      }
    } catch (error) {
      console.error("Error deleting bill:", error);
      toast.error("Failed to delete bill. Please try again.");
    } finally {
      setIsDeleting(false);
      setDeleteDialogOpen(false);
      setBillToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setBillToDelete(null);
  };

  const handleDownload = async (billId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/bills/${billId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error("Failed to fetch bill");
      
      const data = await response.json();
      generateBillPDF(data.bill);
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to load bill details for PDF generation");
    }
  };

  const handleSendSMS = async (billId, billNumber, customerName, phoneNumber) => {
    if (!phoneNumber) {
      toast.error("Customer phone number not available");
      return;
    }

    // Prevent multiple clicks
    if (sendingSMS[billId]) {
      // console.log("SMS already being sent for bill:", billId);
      return;
    }

    // console.log("🔵 Sending SMS for bill:", billNumber, "to:", customerName, "phone:", phoneNumber);
    
    setSendingSMS(prev => ({ ...prev, [billId]: true }));
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/bills/${billId}/send-sms`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      // console.log("🔵 SMS API response:", data);

      if (data.success) {
        toast.success("SMS sent successfully!");
        setSmsDialogOpen(false);
        setSelectedBillForSMS(null);
      } else {
        console.error("❌ SMS API error:", data);
        toast.error(data.message || "Failed to send SMS");
      }
    } catch (error) {
      console.error("❌ SMS sending error:", error);
      toast.error("Failed to send SMS. Please try again.");
    } finally {
      setSendingSMS(prev => ({ ...prev, [billId]: false }));
    }
  };

  const handleOpenSmsDialog = (billData) => {
    if (!billData.PhoneNumber) {
      toast.error("Customer phone number not available");
      return;
    }
    setSelectedBillForSMS(billData);
    setSmsDialogOpen(true);
  };

  const handleSmsConfirm = () => {
    if (selectedBillForSMS) {
      handleSendSMS(
        selectedBillForSMS.BillId,
        selectedBillForSMS.BillNumber,
        selectedBillForSMS.CustomerName,
        selectedBillForSMS.PhoneNumber
      );
    }
  };

  const handleEdit = (billId) => {
    navigate(`/edit-bill?id=${billId}`);
  };

  const handleView = (billId) => {
    navigate(`/bill-details?id=${billId}`);
  };

  // Filter by bill number or customer name or timestamp
  const filteredRows = billData.filter(
    (r) =>
      r.BillNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
      r.CustomerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formatTimestamp(r.CreatedAt).toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AppLayout>
      <Box
        sx={{
          p: { xs: 1, sm: 2, md: 4 },
          minHeight: "calc(100vh - 80px)",
        }}
      >
        {/* Title Section */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              letterSpacing: { xs: 0.5, sm: 1.5, md: 3 },
              fontSize: { xs: "0.85rem", sm: "1.2rem", md: "1.5rem" },
              color: "#BC965E",
              textDecoration: "underline",
              textUnderlineOffset: { xs: 4, sm: 8, md: 12 },
              textDecorationThickness: 2,
              wordBreak: "break-word",
            }}
          >
            BILL CREATION
          </Typography>
        </Box>

        {/* Search Bar and Create Button Section */}
        <Box sx={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          gap: 2,
          mb: 3,
          flexDirection: { xs: "column", sm: "row" }
        }}>
          <TextField
            placeholder="Search by ID / Name / Time..."
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
            size="small"
            sx={{
              width: { xs: "100%", sm: "60%", md: "50%" },
              "& .MuiOutlinedInput-root": {
                bgcolor: "#2d2d2d",
                borderRadius: 2,
                border: "1px solid #C4A574",
                color: "#C4A574",
                "& fieldset": {
                  borderColor: "#C4A574",
                },
                "&:hover fieldset": {
                  borderColor: "#C4A574",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C4A574",
                },
              },
              "& .MuiOutlinedInput-input": {
                color: "#C4A574",
                fontSize: { xs: "0.75rem", sm: "0.85rem", md: "1rem" },
                "&::placeholder": {
                  color: "#C4A574",
                  opacity: 0.6,
                },
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearchClick}
                    sx={{
                      bgcolor: "#C4A574",
                      color: "#000",
                      "&:hover": { bgcolor: "#B39565" },
                      p: { xs: 0.5, sm: 0.75, md: 1 },
                      mr: 0.5,
                    }}
                  >
                    <SearchIcon sx={{ fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" } }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          
          {/* Create Bill Button - Always Visible */}
          <Button
            variant="contained"
            onClick={() => navigate("/create-bill")}
            sx={{
              bgcolor: "#C4A574",
              color: "#000",
              fontWeight: 700,
              px: { xs: 2, sm: 3 },
              py: { xs: 1, sm: 1.2 },
              fontSize: { xs: "0.8rem", sm: "0.9rem" },
              borderRadius: 2,
              textTransform: "none",
              whiteSpace: "nowrap",
              "&:hover": { 
                bgcolor: "#B39565",
                transform: "translateY(-1px)",
                boxShadow: "0 4px 12px rgba(196, 165, 116, 0.3)"
              },
              transition: "all 0.2s ease-in-out",
              boxShadow: "0 2px 8px rgba(196, 165, 116, 0.2)"
            }}
          >
            + Create Bill
          </Button>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2, maxWidth: 1100, mx: "auto", backgroundColor: "rgb(10 0 0 / 29%)" }}
            onClose={() => setError(null)}
          >
            {error}
          </Alert>
        )}

        {/* Loading State */}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 400,
            }}
          >
            <CircularProgress sx={{ color: "#C4A574" }} />
          </Box>
        ) : (
          <>
            {/* Table Container */}
            <Box sx={{ maxWidth: 1100, mx: "auto", mb: 3 }}>
              <Paper
                elevation={8}
                sx={{
                  borderRadius: 2,
                  overflow: "hidden",
                  backgroundColor: "#1e1e1e",
                  border: "1px solid rgba(196, 165, 116, 0.2)",
                }}
              >
                {/* Mobile Card View for xs screens */}
                <Box sx={{ display: { xs: "block", sm: "none" } }}>
                  {filteredRows.length === 0 ? (
                    <Box sx={{ textAlign: "center", py: 4, px: 2 }}>
                      <Typography variant="h6" sx={{ color: "#C4A574", fontWeight: 700, mb: 1 }}>
                        No Bills Found
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#999", mb: 2 }}>
                        You haven't created any bills yet.
                      </Typography>
                    </Box>
                  ) : (
                    <Box sx={{ p: 2 }}>
                      {(rowsPerPage > 0
                        ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : filteredRows
                      ).map((row) => {
                        const initials = getInitials(row.CustomerName);
                        const avatarColor = getAvatarColor(row.CustomerName);

                        return (
                          <Box
                            key={row.BillId}
                            sx={{
                              bgcolor: "#2a2a2a",
                              borderRadius: 2,
                              p: 2,
                              mb: 2,
                              border: "1px solid #444"
                            }}
                          >
                            {/* Header Row */}
                            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                              <Avatar
                                sx={{
                                  bgcolor: avatarColor,
                                  color: "#fff",
                                  fontWeight: 700,
                                  width: 32,
                                  height: 32,
                                  mr: 2,
                                  fontSize: "0.8rem"
                                }}
                              >
                                {initials}
                              </Avatar>
                              <Box sx={{ flex: 1 }}>
                                <Typography sx={{ color: "#C4A574", fontWeight: 600, fontSize: "0.9rem" }}>
                                  {row.BillNumber}
                                </Typography>
                                <Typography sx={{ color: "#fff", fontSize: "0.85rem" }}>
                                  {row.CustomerName}
                                </Typography>
                              </Box>
                            </Box>

                            {/* Timestamp */}
                            <Typography sx={{ color: "#888", fontSize: "0.75rem", mb: 2 }}>
                              {formatTimestamp(row.CreatedAt)}
                            </Typography>

                            {/* Actions */}
                            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                              <Button
                                size="small"
                                onClick={() => handleView(row.BillId)}
                                sx={{
                                  bgcolor: "#C4A574",
                                  color: "#000",
                                  "&:hover": { bgcolor: "#b68649" },
                                  fontSize: "0.7rem",
                                  px: 1.5,
                                  py: 0.5
                                }}
                              >
                                View
                              </Button>

                              {userRole === "Admin" && (
                                <>
                                  <IconButton
                                    size="small"
                                    onClick={() => handleOpenSmsDialog(row)}
                                    disabled={sendingSMS[row.BillId]}
                                    sx={{ 
                                      color: sendingSMS[row.BillId] ? "#666" : "#4CAF50", 
                                      p: 0.5 
                                    }}
                                  >
                                    {sendingSMS[row.BillId] ? (
                                      <CircularProgress size={16} sx={{ color: "#666" }} />
                                    ) : (
                                      <SmsIcon fontSize="small" />
                                    )}
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={() => handleDownload(row.BillId)}
                                    sx={{ color: "#1976d2", p: 0.5 }}
                                  >
                                    <DownloadIcon fontSize="small" />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={() => handleEdit(row.BillId)}
                                    sx={{ color: "#C4A574", p: 0.5 }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>

                                  <IconButton
                                    size="small"
                                    onClick={() => handleDeleteClick(row)}
                                    sx={{ color: "#e53935", p: 0.5 }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </>
                              )}
                            </Box>
                          </Box>
                        );
                      })}

                      {/* Mobile Pagination */}
                      <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                        <TablePagination
                          rowsPerPageOptions={[5]}
                          component="div"
                          count={filteredRows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          sx={{
                            color: "#C4A574",
                            ".MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": { 
                              color: "#C4A574",
                              fontSize: "0.75rem"
                            },
                            ".MuiTablePagination-actions button": { color: "#C4A574" },
                            ".MuiSelect-icon": { color: "#C4A574" }
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>

                {/* Desktop Table View for sm+ screens */}
                <Box sx={{ display: { xs: "none", sm: "block" } }}>
                  <TableContainer>
                    <Table sx={{ minWidth: { sm: 500, md: 700 } }}>
                      {/* Table Header */}
                      <TableHead>
                        <TableRow
                          sx={{
                            backgroundColor: "#C4A574",
                            "& th": {
                              color: "#000",
                              fontWeight: 700,
                              fontSize: { sm: "0.7rem", md: "0.85rem" },
                              border: "none",
                              padding: { sm: "0.5rem", md: "0.75rem" },
                              whiteSpace: "nowrap",
                            },
                          }}
                        >
                          <TableCell>Photo</TableCell>
                          <TableCell>ID</TableCell>
                          <TableCell sx={{ display: { sm: "none", md: "table-cell" } }}>Timestamp</TableCell>
                          <TableCell sx={{ minWidth: { sm: "120px", md: "150px" } }}>Name</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>

                      {/* Table Body */}
                      <TableBody>
                        {filteredRows.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <Typography variant="h6" sx={{ color: "#C4A574", fontWeight: 700, mb: 1 }}>
                                  No Bills Found
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#999", mb: 2 }}>
                                  You haven't created any bills yet. Get started by creating your first bill.
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ) : (
                          (rowsPerPage > 0
                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : filteredRows
                          ).map((row) => {
                            const initials = getInitials(row.CustomerName);
                            const avatarColor = getAvatarColor(row.CustomerName);

                            return (
                              <TableRow
                                key={row.BillId}
                                sx={{
                                  backgroundColor: "#2a2a2a",
                                  borderBottom: "1px solid rgba(196, 165, 116, 0.1)",
                                  "& td": {
                                    color: "#fff",
                                    border: "none",
                                    padding: { sm: "0.5rem", md: "0.75rem" },
                                    verticalAlign: "middle",
                                    fontSize: { sm: "0.7rem", md: "0.85rem" },
                                  },
                                  "&:hover": { backgroundColor: "#333" },
                                  transition: "background-color 0.2s ease",
                                }}
                              >
                                {/* Photo Avatar */}
                                <TableCell>
                                  <Avatar
                                    sx={{
                                      bgcolor: avatarColor,
                                      color: "#fff",
                                      fontWeight: 700,
                                      width: { sm: 28, md: 36 },
                                      height: { sm: 28, md: 36 },
                                      border: "1px solid #C4A574",
                                      fontSize: { sm: "0.7rem", md: "0.85rem" },
                                    }}
                                  >
                                    {initials}
                                  </Avatar>
                                </TableCell>

                                {/* ID */}
                                <TableCell sx={{ fontWeight: 600, color: "#fff", fontSize: { sm: "0.7rem", md: "0.85rem" } }}>
                                  {row.BillNumber}
                                </TableCell>

                                {/* Timestamp */}
                                <TableCell sx={{ color: "#C4A574", fontSize: { sm: "0.65rem", md: "0.75rem" }, display: { sm: "none", md: "table-cell" } }}>
                                  {formatTimestamp(row.CreatedAt).substring(0, 10)}
                                </TableCell>

                                {/* Name */}
                                <TableCell sx={{ 
                                  color: "#fff", 
                                  fontSize: { sm: "0.7rem", md: "0.85rem" },
                                  maxWidth: { sm: "120px", md: "150px" },
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                }}>
                                  {row.CustomerName}
                                </TableCell>

                                {/* Actions */}
                                <TableCell align="center" sx={{ p: { sm: 0.25, md: 0.5 } }}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: { sm: 0.25, md: 0.5 },
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    {/* SMS Icon - Admin only */}
                                    {userRole === "Admin" && (
                                      <IconButton
                                        size="small"
                                        onClick={() => handleOpenSmsDialog(row)}
                                        disabled={sendingSMS[row.BillId]}
                                        sx={{
                                          color: sendingSMS[row.BillId] ? "#666" : "#4CAF50",
                                          p: { sm: 0.25, md: 0.5 },
                                          "& .MuiSvgIcon-root": { fontSize: { sm: "1rem", md: "1.25rem" } },
                                          "&:hover": { bgcolor: "rgba(76, 175, 80, 0.1)" },
                                          "&:disabled": { color: "#666" },
                                        }}
                                      >
                                        {sendingSMS[row.BillId] ? (
                                          <CircularProgress size={16} sx={{ color: "#666" }} />
                                        ) : (
                                          <SmsIcon />
                                        )}
                                      </IconButton>
                                    )}

                                    {/* Download Icon - Admin only */}
                                    {userRole === "Admin" && (
                                      <IconButton
                                        size="small"
                                        onClick={() => handleDownload(row.BillId)}
                                        sx={{
                                          color: "#1976d2",
                                          p: { sm: 0.25, md: 0.5 },
                                          "& .MuiSvgIcon-root": { fontSize: { sm: "1rem", md: "1.25rem" } },
                                          "&:hover": { bgcolor: "rgba(25, 118, 210, 0.1)" },
                                        }}
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    )}

                                    {/* View Button */}
                                    <Button
                                      size="small"
                                      onClick={() => handleView(row.BillId)}
                                      sx={{
                                        bgcolor: "#C4A574",
                                        color: "#000",
                                        fontWeight: 600,
                                        fontSize: { sm: "0.65rem", md: "0.75rem" },
                                        px: { sm: 1, md: 1.5 },
                                        py: { sm: 0.25, md: 0.4 },
                                        borderRadius: 1,
                                        textTransform: "none",
                                        minWidth: "auto",
                                        "&:hover": { bgcolor: "#B39565" },
                                      }}
                                    >
                                      View
                                    </Button>

                                    {/* Edit Button - Admin only */}
                                    {userRole === "Admin" && (
                                      <Button
                                        size="small"
                                        onClick={() => handleEdit(row.BillId)}
                                        sx={{
                                          bgcolor: "transparent",
                                          border: "1px solid #C4A574",
                                          color: "#C4A574",
                                          fontWeight: 600,
                                          fontSize: { sm: "0.65rem", md: "0.75rem" },
                                          px: { sm: 1, md: 1.5 },
                                          py: { sm: 0.25, md: 0.4 },
                                          borderRadius: 1,
                                          textTransform: "none",
                                          minWidth: "auto",
                                          "&:hover": { bgcolor: "rgba(196, 165, 116, 0.1)" },
                                        }}
                                      >
                                        Edit
                                      </Button>
                                    )}

                                    {/* Delete Icon - Admin only */}
                                    {userRole === "Admin" && (
                                      <IconButton
                                        size="small"
                                        onClick={() => handleDeleteClick(row)}
                                        sx={{
                                          color: "#ff6b6b",
                                          p: { sm: 0.25, md: 0.5 },
                                          "& .MuiSvgIcon-root": { fontSize: { sm: "1rem", md: "1.25rem" } },
                                          "&:hover": { bgcolor: "rgba(255, 107, 107, 0.1)" },
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    )}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>

                      {/* Table Footer with Pagination */}
                      <TableFooter>
                        <TableRow
                          sx={{
                            backgroundColor: "#1e1e1e",
                            borderTop: "1px solid rgba(196, 165, 116, 0.2)",
                          }}
                        >
                          <TableCell colSpan={5} sx={{ p: 0 }}>
                            <TablePagination
                              rowsPerPageOptions={[5]}
                              component="div"
                              count={filteredRows.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              sx={{
                                color: "#C4A574",
                                "& .MuiTablePagination-toolbar": { color: "#C4A574" },
                                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": { color: "#C4A574", margin: 0 },
                                "& .MuiTablePagination-actions button": { color: "#C4A574" },
                                "& .MuiSelect-icon": { color: "#C4A574" },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </Box>
              </Paper>
            </Box>

            {/* Decorative Fade */}
            <Box
              sx={{
                mt: 6,
                maxWidth: 1100,
                mx: "auto",
                height: 60,
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.3))",
                borderRadius: 2,
              }}
            />
          </>
        )}

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteDialogOpen}
          onClose={isDeleting ? null : handleDeleteCancel}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
          PaperProps={{
            sx: {
              background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)",
              border: "1px solid #444",
              borderRadius: 2,
            }
          }}
        >
          <DialogTitle 
            id="delete-dialog-title"
            sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              background: "linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%)",
              borderBottom: '2px solid #ff6b6b',
              color: '#fff',
              pb: 2
            }}
          >
            <Typography variant="h6" component="div" sx={{ fontWeight: 600, color: '#ff6b6b' }}>
              Confirm Delete
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ pt: 3, bgcolor: 'transparent' }}>
            <DialogContentText 
              id="delete-dialog-description"
              sx={{ color: '#fff', mb: 2 }}
            >
              Are you sure you want to delete bill <strong style={{ color: '#C4A574' }}>{billToDelete?.BillNumber}</strong>? This action cannot be undone.
            </DialogContentText>
            {billToDelete?.SchemeCreditApplied > 0 && (
              <Box sx={{ 
                mt: 2, 
                p: 2, 
                bgcolor: 'rgba(156, 39, 176, 0.1)', 
                borderRadius: 1,
                border: '1px solid rgba(156, 39, 176, 0.3)'
              }}>
                <Typography variant="body2" sx={{ color: '#ce93d8' }}>
                  <strong>Note:</strong> Scheme credit of <strong>₹{parseFloat(billToDelete.SchemeCreditApplied || 0).toFixed(2)}</strong> will be restored to the customer.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ 
            p: 2, 
            background: "linear-gradient(135deg, #2d2d2d 0%, #1a1a1a 100%)",
            borderTop: '1px solid #444',
            gap: 1
          }}>
            <Button 
              onClick={handleDeleteCancel} 
              disabled={isDeleting}
              sx={{
                color: '#C4A574',
                borderColor: '#C4A574',
                '&:hover': {
                  bgcolor: 'rgba(196, 165, 116, 0.1)',
                  borderColor: '#C4A574'
                }
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button 
              onClick={handleDeleteConfirm} 
              variant="contained" 
              autoFocus
              disabled={isDeleting}
              startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : null}
              sx={{
                bgcolor: '#ff6b6b',
                color: '#fff',
                '&:hover': {
                  bgcolor: '#ff5252'
                },
                '&:disabled': {
                  bgcolor: 'rgba(255, 107, 107, 0.3)',
                  color: 'rgba(255, 255, 255, 0.5)'
                }
              }}
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* SMS Confirmation Dialog */}
        <Dialog
          open={smsDialogOpen}
          onClose={() => setSmsDialogOpen(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: "#2d2d2d",
              border: "1px solid #444"
            }
          }}
        >
          <DialogTitle
            sx={{
              bgcolor: "#4CAF50",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <SmsIcon />
            <Typography variant="h6" fontWeight={700}>
              Send Bill via SMS
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ mt: 2, bgcolor: "#2d2d2d" }}>
            <Typography variant="body1" sx={{ mb: 2, color: "#E5E7EB" }}>
              Send bill details to customer via SMS?
            </Typography>
            {selectedBillForSMS && (
              <Box sx={{ p: 2, bgcolor: "#3a3a3a", borderRadius: 1, border: "1px solid #555" }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#4CAF50" }}>
                  Customer: {selectedBillForSMS.CustomerName}
                </Typography>
                <Typography variant="body2" sx={{ color: "#9CA3AF", mb: 0.5 }}>
                  Phone: {selectedBillForSMS.PhoneNumber}
                </Typography>
                <Typography variant="body2" sx={{ color: "#9CA3AF", mb: 0.5 }}>
                  Bill: #{selectedBillForSMS.BillNumber}
                </Typography>
                <Typography variant="body2" sx={{ color: "#9CA3AF" }}>
                  Date: {formatTimestamp(selectedBillForSMS.CreatedAt)}
                </Typography>
              </Box>
            )}
            <Typography variant="body2" sx={{ mt: 2, color: "#9CA3AF", fontStyle: "italic" }}>
              The SMS will include bill details from your store.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2, bgcolor: "#2d2d2d" }}>
            <Button
              onClick={() => setSmsDialogOpen(false)}
              disabled={selectedBillForSMS && sendingSMS[selectedBillForSMS.BillId]}
              sx={{
                color: "#9CA3AF",
                "&:hover": { bgcolor: "rgba(156, 163, 175, 0.1)" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSmsConfirm}
              disabled={selectedBillForSMS && sendingSMS[selectedBillForSMS.BillId]}
              variant="contained"
              sx={{
                bgcolor: "#4CAF50",
                color: "#fff",
                "&:hover": { bgcolor: "#45a049" },
              }}
            >
              {selectedBillForSMS && sendingSMS[selectedBillForSMS.BillId] ? (
                <CircularProgress size={24} />
              ) : (
                "Send SMS"
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </AppLayout>
  );
}

